import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

const WorkflowUtilityPanel = ({
  title,
  subtitle,
  onClose,
  children,
  headerActions,
  className,
  widthClass = 'w-[420px]',
  testId,
}) => (
  <div
    className={cn(
      'flex h-[calc(100vh-120px)] shrink-0 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white text-slate-900 shadow-xl',
      widthClass,
      className,
    )}
    data-testid={testId}
  >
    <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
      <div className="min-w-0 flex-1">
        {title ? <h2 className="text-lg font-semibold text-slate-900">{title}</h2> : null}
        {subtitle && <p className={cn('text-sm text-slate-500', title && 'mt-1')}>{subtitle}</p>}
      </div>
      <div className="flex items-center gap-1">
        {headerActions}
        <button
          type="button"
          onClick={onClose}
          className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          aria-label="Close panel"
        >
          <X size={16} />
        </button>
      </div>
    </div>
    <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
  </div>
);

export default WorkflowUtilityPanel;
